import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=849961b4&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDrawer,QScrollArea,QList,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon,QImg,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDrawer,QScrollArea,QList,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon,QImg})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
